<template>
  <transition name="fade">
    <div id="main-loader" v-if="isLoading"></div>
  </transition>
</template>

<script>
export default {
  props: {
    isLoading: Boolean
  },
  watch: {
    isLoading: function(val) {
      if (!val) {
        this.$refs.mask;
      }
    }
  }
};
</script>

<style lang="scss">
#main-loader {
  cursor: wait;
  position: fixed;
  z-index: var(--z-index-main-loader);
  background: var(--main-loader-background-color);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

#app.is-loading {
  .__cov-progress {
    background-color: var(--main-loader-progress-bar-color) !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>